import type { ActionHandler } from '../types'

export const handleApplyCondition: ActionHandler<'APPLY_CONDITION'> = async (ctx, payload) => {
  const { data: char } = await ctx.supabase
    .from('characters')
    .select('active_conditions')
    .eq('id', ctx.characterId)
    .single()

  if (!char) throw new Error('Character not found')

  const oldConditions = char.active_conditions as string[]
  if (oldConditions.includes(payload.condition)) {
    return { effects: [], label: `Condition already active: ${payload.condition}` }
  }

  const newConditions = [...oldConditions, payload.condition]

  const { error } = await ctx.supabase
    .from('characters')
    .update({ active_conditions: newConditions })
    .eq('id', ctx.characterId)

  if (error) throw error

  return {
    effects: [{
      character_id: ctx.characterId,
      target_table: 'characters',
      target_row_id: ctx.characterId,
      target_field: 'active_conditions',
      operation: 'UPDATE' as const,
      old_value: oldConditions,
      new_value: newConditions,
    }],
    label: `Apply condition: ${payload.condition}`,
  }
}

export const handleRemoveCondition: ActionHandler<'REMOVE_CONDITION'> = async (ctx, payload) => {
  const { data: char } = await ctx.supabase
    .from('characters')
    .select('active_conditions')
    .eq('id', ctx.characterId)
    .single()

  if (!char) throw new Error('Character not found')

  const oldConditions = char.active_conditions as string[]
  const newConditions = oldConditions.filter(c => c !== payload.condition)

  if (newConditions.length === oldConditions.length) {
    return { effects: [], label: `Condition not active: ${payload.condition}` }
  }

  const { error } = await ctx.supabase
    .from('characters')
    .update({ active_conditions: newConditions })
    .eq('id', ctx.characterId)

  if (error) throw error

  return {
    effects: [{
      character_id: ctx.characterId,
      target_table: 'characters',
      target_row_id: ctx.characterId,
      target_field: 'active_conditions',
      operation: 'UPDATE' as const,
      old_value: oldConditions,
      new_value: newConditions,
    }],
    label: `Remove condition: ${payload.condition}`,
  }
}
